import { type SVGProps } from "react";

export function StoopMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect x="4.5" y="4" width="10" height="17" rx="1.25" ry="1.25" />
      <circle cx="11.75" cy="13" r="0.65" fill="currentColor" stroke="none" />
      <path
        d="M16 8.5 C 19 9, 20.5 11, 19.75 13.25 C 17.75 12.75, 16.25 11, 16 8.5 Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.75"
      />
      <path d="M16.4 9 L 19.4 12.4" strokeWidth="0.85" />
    </svg>
  );
}
